import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { EtapaBase } from '@app/shared';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';

@Injectable()
export class TimeContolDataService {
  constructor(private http: HttpClient, private toastr: ToastrService,private api: EndpointService) { }


  /**
   * Carga las etapas del sistema
   *
   * @return {*}  {Observable<EtapaBase[]>}
   * @memberof TimeContolDataService
   */
  getStage(): Observable<EtapaBase[]> {
    return this.http.get<EtapaBase[]>(this.api.get('adminStages'));
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/shared/time-contol.data.service.ts